import get from '@invitato/helpers/dist/getLocale';

export default {
  thanks: get('Terima kasih,', 'Thank you,'),
};
